import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { IKeg } from '../../../models/keg';
import { ToastService } from '../../../services/toast.service';
import { ToastController, AlertController, ModalController, IonicModule } from '@ionic/angular';
import { UnitsHelper } from '../../../services/units.helper';

import * as fromBeverage from "app/state/beverage";
import * as fromBar from "app/state/bar";
import * as fromUser from "app/state/user";
import * as fromUnits from "app/state/units";
import * as fromKegs from "app/state/keg";
import * as fromTaps from "app/state/tap";
import * as fromLocations from "app/state/location";

import { Store } from '@ngrx/store';
import * as fromKeg from 'app/state/keg';
// import { getFromParams } from 'app/state/keg';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormComponent } from './form/form.component';
import { Router, RouterModule } from '@angular/router';
import { HelpModalComponent } from 'app/components/help-modal/help-modal.component';

@Component({
  selector: 'app-keg-detail',
  templateUrl: './keg-detail.page.html',
  styleUrls: ['./keg-detail.page.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FormsModule, ReactiveFormsModule, IonicModule, RouterModule, FormComponent]
})
export class KegDetailPage implements OnInit {

  @Input() isModal!: boolean;
  @Input() itemId!: string;

  plaatoExists: boolean = false;
  kegtronExists: boolean = false;
  customKegMonExists: boolean = false;
  item = this.store.selectSignal(fromKegs.getKegWithUnitsFromParams);
  barId = this.store.selectSignal(fromUser.selectBarId);
  userId = this.store.selectSignal(fromUser.selectUserId);
  bar = this.store.selectSignal(fromBar.selectBar);
  units = this.store.selectSignal(fromUnits.getUnits);
  beverages = this.store.selectSignal(fromBeverage.selectAllEntities);
  taps = this.store.selectSignal(fromTaps.selectAllItems);
  locations = this.store.selectSignal(fromLocations.selectAllItems);

  constructor(
    private store: Store,
    private router: Router,
    private modalController: ModalController,
    public alertController: AlertController,
    public toastController: ToastController,
    public toastService: ToastService,
    public unitHelper: UnitsHelper,

  ) { }

  ngOnInit(): void {
    if (this.itemId) {
      this.item = this.store.selectSignal(fromKeg.selectEntity(this.itemId));
    }
  }

  softUpdateKeg(event: any) {
    this.store.dispatch(fromKeg.softUpdate({ id: event.id, data: event.data, uid: event.uid }));
  }

  softUpdateTap(event: any) {
    this.store.dispatch(fromTaps.softUpdate({ id: event.id, data: event.data, uid: event.uid }));
  }

  closeModal(item: IKeg) {
    this.modalController.dismiss({
      dismissed: true,
      keg: item
    });
  }

  async confirmDelete(keg: IKeg) {
    const alert = await this.alertController.create({
      header: 'Confirm!',
      message: 'Are you sure you want to delete?',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          cssClass: 'secondary'
        }, {
          text: 'Okay',
          handler: () => {
            this.delete(keg);
          }
        }
      ]
    });

    await alert.present();
  }

  private delete(keg: IKeg) {
    if (keg.id) {
      this.store.dispatch(fromKeg.deleteItem({ id: keg.id }));
      this.router.navigate(['inventory/kegs']);
    }
  }

  public async openHelpModal() {
    const modal = await this.modalController.create({
      component: HelpModalComponent,
      componentProps: {
        component: 'KegDetailPage'
      }
    });
    return await modal.present();
  }


}
